// Alinhado a frontend/src/services/api.js
const API_BASE =
  process.env.REACT_APP_API_BASE_URL_PROD ||
  process.env.REACT_APP_API_URL ||
  ''

/**
 * Converte URL relativa de imagem (ex.: /uploads/...) em URL absoluta do backend.
 */
export function resolveMediaUrl(url) {
  if (!url || typeof url !== 'string') return ''
  const t = url.trim()
  if (!t) return ''
  if (/^https?:\/\//i.test(t) || t.startsWith('data:')) return t
  if (t.startsWith('//')) return `https:${t}`

  let base = API_BASE.replace(/\/$/, '')
  if (!base && typeof window !== 'undefined') {
    base = `${window.location.origin.replace(/\/$/, '')}`
  }
  const path = t.startsWith('/') ? t : `/${t}`
  return `${base}${path}`
}

/**
 * Extrai a URL bruta da imagem do produto (image_url, image ou images[0]).
 */
export function getProductImageRaw(product) {
  if (!product || typeof product !== 'object') return ''

  const direct = product.image_url || product.image || product.imageUrl
  if (typeof direct === 'string' && direct.trim()) return direct.trim()

  const imgs = product.images
  if (Array.isArray(imgs) && imgs.length > 0) {
    const first = imgs[0]
    const nested =
      (first && (first.image_url || first.imageUrl || first.url)) || ''
    if (typeof nested === 'string' && nested.trim()) return nested.trim()
  }

  return ''
}

/** URL absoluta pronta para <img src>. */
export function resolveProductImageUrl(product) {
  return resolveMediaUrl(getProductImageRaw(product))
}
